// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/extract-policy-types.js from policies_all_ctus_counties.json
// Run 'npm run generate-policy-types' to regenerate

// Policy Type options
export const policyTypeOptions = [
    {
        "value": "ADU and Density Policies",
        "label": "ADU and Density Policies",
        "color": "#ff9e44"
    },
    {
        "value": "Administrative Policies",
        "label": "Administrative Policies",
        "color": "#33c8bc"
    },
    {
        "value": "Code Compliance/Crime Free Ordinances",
        "label": "Code Compliance/Crime Free Ordinances",
        "color": "#ff8c26"
    },
    {
        "value": "Energy Efficiency Incentives",
        "label": "Energy Efficiency Incentives",
        "color": "#2e86c1"
    },
    {
        "value": "Financial Tools",
        "label": "Financial Tools",
        "color": "#58d58d"
    },
    {
        "value": "Homeownership/Wealth-Building",
        "label": "Homeownership/Wealth-Building",
        "color": "#e74c3c"
    },
    {
        "value": "Housing Trust Fund",
        "label": "Housing Trust Fund",
        "color": "#f4d03f"
    },
    {
        "value": "Inclusionary Housing Policy",
        "label": "Inclusionary Housing Policy",
        "color": "#8e44ad"
    },
    {
        "value": "Land Trusts",
        "label": "Land Trusts",
        "color": "#949494"
    },
    {
        "value": "Naturally Occurring Affordable Housing Preservation",
        "label": "Naturally Occurring Affordable Housing Preservation",
        "color": "#00ffee"
    },
    {
        "value": "Partnerships",
        "label": "Partnerships",
        "color": "#ff00ff"
    },
    {
        "value": "Renter Protections and Policies",
        "label": "Renter Protections and Policies",
        "color": "#2196f3"
    }
];

// Policy Subtype options - organized by parent policy type
export const policySubtypeOptions = {
    "ADU and Density Policies": [
        {
            "value": "Accessory Dwelling Unit (ADU) Policy",
            "label": "Accessory Dwelling Unit (ADU) Policy",
            "color": "#b36f30"
        },
        {
            "value": "Allow 2, 3 and 4 Unit in Single-Family Zoned Areas",
            "label": "Allow 2, 3 and 4 Unit in Single-Family Zoned Areas",
            "color": "#d9863a"
        },
        {
            "value": "Designate Density Above 15 Units per Acre",
            "label": "Designate Density Above 15 Units per Acre",
            "color": "#ff9e44"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#ffb64e"
        },
        {
            "value": "Policy Allowing Multi-Family Units in Single-Family Zoned Areas",
            "label": "Policy Allowing Multi-Family Units in Single-Family Zoned Areas",
            "color": "#ffcd58"
        }
    ],
    "Administrative Policies": [
        {
            "value": "COVID-19 Program",
            "label": "COVID-19 Program",
            "color": "#248c84"
        },
        {
            "value": "City Provides at Least 1 Locally Funded or Administered Housing Program or Service",
            "label": "City Provides at Least 1 Locally Funded or Administered Housing Program or Service",
            "color": "#289d94"
        },
        {
            "value": "Covering All or a Portion of Administrative Expenses Incurred in Administering a Federal, State, or County Program",
            "label": "Covering All or a Portion of Administrative Expenses Incurred in Administering a Federal, State, or County Program",
            "color": "#2caea4"
        },
        {
            "value": "Equity In Development And Hiring Policy",
            "label": "Equity In Development And Hiring Policy",
            "color": "#31bfb4"
        },
        {
            "value": "Housing-Related Plan",
            "label": "Housing-Related Plan",
            "color": "#35d1c4"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#3ae2d4"
        },
        {
            "value": "Removal Of Racial Restrictive Covenants",
            "label": "Removal Of Racial Restrictive Covenants",
            "color": "#3ef3e4"
        },
        {
            "value": "Rental Licensing Program",
            "label": "Rental Licensing Program",
            "color": "#42fff4"
        }
    ],
    "Code Compliance/Crime Free Ordinances": [
        {
            "value": "Code Compliance Program/Ordinance",
            "label": "Code Compliance Program/Ordinance",
            "color": "#b3621b"
        },
        {
            "value": "Crime Free Ordinance",
            "label": "Crime Free Ordinance",
            "color": "#ffb631"
        }
    ],
    "Energy Efficiency Incentives": [
        {
            "value": "New Const Rental Energy Efficiency",
            "label": "New Const Rental Energy Efficiency",
            "color": "#205e87"
        },
        {
            "value": "PACE Financing",
            "label": "PACE Financing",
            "color": "#2772a4"
        },
        {
            "value": "Preservation of Naturally Occurring Affordable Housing/Rental Rehab",
            "label": "Preservation of Naturally Occurring Affordable Housing/Rental Rehab",
            "color": "#2e86c1"
        },
        {
            "value": "Single Family Energy Efficiency",
            "label": "Single Family Energy Efficiency",
            "color": "#359ade"
        },
        {
            "value": "Single Family Rehab Energy Efficiency",
            "label": "Single Family Rehab Energy Efficiency",
            "color": "#3caefb"
        }
    ],
    "Financial Tools": [
        {
            "value": "Bonding",
            "label": "Bonding",
            "color": "#3e9563"
        },
        {
            "value": "Building Permit Fee Reimbursement For Affordable Housing",
            "label": "Building Permit Fee Reimbursement For Affordable Housing",
            "color": "#44a56d"
        },
        {
            "value": "Fee Reductions",
            "label": "Fee Reductions",
            "color": "#4bb578"
        },
        {
            "value": "Housing Improvement Area",
            "label": "Housing Improvement Area",
            "color": "#51c582"
        },
        {
            "value": "Housing-Related Plan",
            "label": "Housing-Related Plan",
            "color": "#58d58d"
        },
        {
            "value": "Prioritize Publicly Owned Land",
            "label": "Prioritize Publicly Owned Land",
            "color": "#5fe598"
        },
        {
            "value": "Tax Abatement",
            "label": "Tax Abatement",
            "color": "#65f5a2"
        },
        {
            "value": "Tax Increment Financing Districts",
            "label": "Tax Increment Financing Districts",
            "color": "#6cffad"
        },
        {
            "value": "Tax Increment Financing Pooled Funds",
            "label": "Tax Increment Financing Pooled Funds",
            "color": "#72ffb7"
        }
    ],
    "Homeownership/Wealth-Building": [
        {
            "value": "COVID-19 Program",
            "label": "COVID-19 Program",
            "color": "#a2352a"
        },
        {
            "value": "Down Payment Assistance",
            "label": "Down Payment Assistance",
            "color": "#b93d30"
        },
        {
            "value": "First-Time Homebuyer Assistance",
            "label": "First-Time Homebuyer Assistance",
            "color": "#d04436"
        },
        {
            "value": "Foreclosure Prevention Programs",
            "label": "Foreclosure Prevention Programs",
            "color": "#e74c3c"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#fe5442"
        },
        {
            "value": "Preference Policies",
            "label": "Preference Policies",
            "color": "#ff5b48"
        },
        {
            "value": "Tenants' Rights Policies",
            "label": "Tenants' Rights Policies",
            "color": "#ff634e"
        }
    ],
    "Housing Trust Fund": [
        {
            "value": "Housing Trust Fund",
            "label": "Housing Trust Fund",
            "color": "#f4d03f"
        }
    ],
    "Inclusionary Housing Policy": [
        {
            "value": "Allow Payment in Lieu",
            "label": "Allow Payment in Lieu",
            "color": "#633079"
        },
        {
            "value": "Applies to Funding Assistance",
            "label": "Applies to Funding Assistance",
            "color": "#703588"
        },
        {
            "value": "Applies to Rezoning",
            "label": "Applies to Rezoning",
            "color": "#7c3b97"
        },
        {
            "value": "Fair Housing Policy",
            "label": "Fair Housing Policy",
            "color": "#8841a6"
        },
        {
            "value": "Mandatory % Required for New Housing",
            "label": "Mandatory % Required for New Housing",
            "color": "#9447b4"
        },
        {
            "value": "Mixed-Income (Inclusionary) Housing Policy",
            "label": "Mixed-Income (Inclusionary) Housing Policy",
            "color": "#a04dc3"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#ac53d2"
        },
        {
            "value": "Voluntary Program to Add Affordability",
            "label": "Voluntary Program to Add Affordability",
            "color": "#b958e1"
        }
    ],
    "Land Trusts": [
        {
            "value": "Community Land Trust",
            "label": "Community Land Trust",
            "color": "#949494"
        }
    ],
    "Naturally Occurring Affordable Housing Preservation": [
        {
            "value": "Financial Tools",
            "label": "Financial Tools",
            "color": "#00b3a7"
        },
        {
            "value": "Home Rehabilitation Program",
            "label": "Home Rehabilitation Program",
            "color": "#00ccbe"
        },
        {
            "value": "Housing-Related Plan",
            "label": "Housing-Related Plan",
            "color": "#00e5d6"
        },
        {
            "value": "Local 4D",
            "label": "Local 4D",
            "color": "#00ffee"
        },
        {
            "value": "Low-Interest Rehab Program",
            "label": "Low-Interest Rehab Program",
            "color": "#00ffff"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#00ffff"
        },
        {
            "value": "Rental Rehabilitation Program",
            "label": "Rental Rehabilitation Program",
            "color": "#00ffff"
        }
    ],
    "Partnerships": [
        {
            "value": "At Least 1 Housing Program Operated by a Nonprofit Organization Receiving a Local Financial Contribution",
            "label": "At Least 1 Housing Program Operated by a Nonprofit Organization Receiving a Local Financial Contribution",
            "color": "#b300b3"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#ff00ff"
        },
        {
            "value": "Strong Partnership with County HRA/CDA/EDA",
            "label": "Strong Partnership with County HRA/CDA/EDA",
            "color": "#ff00ff"
        }
    ],
    "Renter Protections and Policies": [
        {
            "value": "Advance Notice of Sale Ordinance",
            "label": "Advance Notice of Sale Ordinance",
            "color": "#1769aa"
        },
        {
            "value": "COVID-19 Program",
            "label": "COVID-19 Program",
            "color": "#186fb4"
        },
        {
            "value": "Displacement Prevention Policy",
            "label": "Displacement Prevention Policy",
            "color": "#1a75be"
        },
        {
            "value": "Local Rental Assistance Program",
            "label": "Local Rental Assistance Program",
            "color": "#1b7bc7"
        },
        {
            "value": "Nondiscrimination Of Housing Choice Vouchers",
            "label": "Nondiscrimination Of Housing Choice Vouchers",
            "color": "#1c81d1"
        },
        {
            "value": "Notification Of Sale",
            "label": "Notification Of Sale",
            "color": "#1e87db"
        },
        {
            "value": "Other",
            "label": "Other",
            "color": "#1f8de4"
        },
        {
            "value": "Pre Eviction Filing Notice",
            "label": "Pre Eviction Filing Notice",
            "color": "#2093ee"
        },
        {
            "value": "Rent Stabilization Ordinance",
            "label": "Rent Stabilization Ordinance",
            "color": "#2299f8"
        },
        {
            "value": "Rent Subsidy",
            "label": "Rent Subsidy",
            "color": "#239fff"
        },
        {
            "value": "Rental Application Fee Requirement",
            "label": "Rental Application Fee Requirement",
            "color": "#24a5ff"
        },
        {
            "value": "Rental Assistance Program",
            "label": "Rental Assistance Program",
            "color": "#26abff"
        },
        {
            "value": "Right to counsel policy for low-income tenants",
            "label": "Right to counsel policy for low-income tenants",
            "color": "#27b1ff"
        },
        {
            "value": "Security Deposit Requirement",
            "label": "Security Deposit Requirement",
            "color": "#28b7ff"
        },
        {
            "value": "Tenant Screening Requirement",
            "label": "Tenant Screening Requirement",
            "color": "#2abdff"
        },
        {
            "value": "Tenants' Rights Policies",
            "label": "Tenants' Rights Policies",
            "color": "#2bc3ff"
        }
    ]
};
